import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useState } from "react";
import { expiredActionPropsState, filterParams, selectedPracticesListState } from "../../state";
import { ExpiredInsertionAction } from "../../config";
import ActionInsertion from "../../action-insertion/ActionInsertion";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { generateExpiredActionProps } from "../../utils";


const OperatorNoteButton = () => {

    const theme = useTheme();
    const { t } = useTranslation(['expiredManagement']);
    
    const selectedPractices = useRecoilValue(selectedPracticesListState);
    const setExpiredActionProps = useSetRecoilState(expiredActionPropsState);
    const setExpiredPracticesFilter = useSetRecoilState(filterParams);

    const [openActionDialog, setOpenActionDialog] = useState(false);

    const handleClick = async (event: React.MouseEvent) => {
        event.stopPropagation();

        await setExpiredActionProps(generateExpiredActionProps(ExpiredInsertionAction.OPERATOR_NOTES, selectedPractices));

        setOpenActionDialog(true)
    }

    const handleCloseDialog = () => {

        setOpenActionDialog(false);
        setExpiredActionProps(null);
    }

    return (
        <>
            <Button
                onClick={handleClick}
                disabled={!selectedPractices || selectedPractices.length <= 0}
            >
                {t('common.actions.NOTE_OPERATORE')}
            </Button>

            <Dialog open={openActionDialog} fullWidth maxWidth={"xl"}>
                <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>{t(`common.actions.dialog.title.NOTE_OPERATORE`)}</Typography>

                    <IconButton 
                        onClick={handleCloseDialog} 
                        sx={{ml: theme.spacing(4), mr: "0px"}}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                
                <DialogContent>
                    <ActionInsertion
                        //forView
                        onConfirm={() => {
                            handleCloseDialog();
                            
                            //Trigger search with current filters
                            setExpiredPracticesFilter(((prev: any) => {
                                return {...prev};
                            }));
                        }}
                        onClose={handleCloseDialog}
                    />
                </DialogContent>
            </Dialog>
        </>
    )

}

export default OperatorNoteButton;